import { proxyCustomElement, HTMLElement, createEvent, h, Fragment } from '@stencil/core/internal/client';
import { s as state } from './index3.js';
import { d as defineCustomElement$1 } from './button-base2.js';

import { baseCss } from './css.js';
const nlLocalSignupCss = baseCss;

const NlLocalSignupStyle0 = nlLocalSignupCss;

const NlLocalSignup = /*@__PURE__*/ proxyCustomElement(class NlLocalSignup extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.nlLocalSignup = createEvent(this, "nlLocalSignup", 7);
        this.nlSignupNjump = createEvent(this, "nlSignupNjump", 7);
        this.fetchHandler = createEvent(this, "fetchHandler", 7);
        this.titleSignup = 'Create Nostr profile';
        this.description = 'Choose any username, you can always change it later.';
        this.descriptionNjump = 'Proceed to creating your Nostr profile in a new tab.';
        this.signupNjump = false;
        this.isAvailable = false;
    }
    handleInputChange(event) {
        state.nlSignup.signupName = event.target.value;
        // this.nlCheckSignup.emit(`${(event.target as HTMLInputElement).value}@${state.nlSignup.domain}`);
    }
    handleCreateAccount(e) {
        e.preventDefault();
        if (this.signupNjump) {
            this.nlSignupNjump.emit();
        }
        else {
            this.nlLocalSignup.emit(`${state.nlSignup.signupName}`);
        }
    }
    render() {
        return (h(Fragment, { key: '6ea0144cad11803864f8d6b5bc7896d8d9b413cf' }, h("div", { key: 'be257a544937601e20521adac8ec98b46a6c8af5', class: "p-4 overflow-y-auto" }, h("h1", { key: 'c8e91ccc003d0a6e344010a41bb47eeec1abdbf0', class: "nl-title font-bold text-center text-2xl" }, this.titleSignup), h("p", { key: 'e71ee5aa6ac01059b63ee2245800c3659301ec06', class: "nl-description font-light text-center text-sm pt-2 max-w-96 mx-auto" }, this.signupNjump ? this.descriptionNjump : this.description)), h("div", { key: '516c8c44b6936554b96151a4fe4a9b6af614b554', class: "max-w-72 mx-auto" }, !this.signupNjump && (h("div", { key: 'a74e48d36f120fe249abfd57131c2bfde7f3dce4', class: "relative mb-2" }, h("input", { key: 'b77730184df9033291010d4e8ead166be726e8d9', onInput: e => this.handleInputChange(e), type: "text", class: "nl-input peer py-3 px-4 ps-11 block w-full border-transparent rounded-lg text-sm disabled:opacity-50 disabled:pointer-events-none dark:border-transparent", placeholder: "Enter username", value: state.nlSignup.signupName }), h("div", { key: 'cc061801a575391e879759c5873e8256fc68f547', class: "absolute inset-y-0 start-0 flex items-center pointer-events-none ps-4 peer-disabled:opacity-50 peer-disabled:pointer-events-none" }, h("svg", { key: '909c6728e8f26012647a3c9b3de8f4b16ae31e80', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "2", stroke: this.isAvailable ? '#00cc00' : 'currentColor', class: "flex-shrink-0 w-4 h-4 text-gray-500" }, h("path", { key: '0306f3c147c376bbd7b01b3e2eca178f339ac167', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" }))))), h("div", { key: '77368eeb60108aeec228e83aa206ef2b2d3fa27a', class: "ps-4 pe-4 overflow-y-auto" }, h("p", { key: 'e87a1ae66cfaf9a75cb723a29e57c5e0ff54aabd', class: "nl-error font-light text-center text-sm max-w-96 mx-auto" }, state.error)), h("button-base", { key: '99ce9506bf5db9c26d916314e1e5700bf515f1b7', disabled: state.isLoading, onClick: e => this.handleCreateAccount(e), titleBtn: this.signupNjump ? 'Get started' : 'Create profile' }, state.isLoading ? (h("span", { slot: "icon-start", class: "animate-spin-loading inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-slate-900 dark:text-gray-300 rounded-full", role: "status", "aria-label": "loading" })) : (h("svg", { slot: "icon-start", style: { display: 'none' }, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z" })))))));
    }
    static get style() { return NlLocalSignupStyle0; }
}, [0, "nl-local-signup", {
        "titleSignup": [1, "title-signup"],
        "description": [1],
        "descriptionNjump": [1, "description-njump"],
        "signupNjump": [4, "signup-njump"],
        "isAvailable": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-local-signup", "button-base"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-local-signup":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlLocalSignup);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlLocalSignup as N, defineCustomElement as d };

//# sourceMappingURL=nl-local-signup2.js.map